import React from "react";
import packageJson from "../../../../package.json";
import "./display-version.scss";

interface DisplayVersionProps {
  showRelease?: boolean;
}

const formatBuildDate = (isoString: string) => {
  if (!isoString) return "N/A";
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return "N/A";
  }
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const DisplayVersion: React.FC<DisplayVersionProps> = ({ showRelease }) => {
  const buildDate = process.env.REACT_APP_BUILD_DATE || "N/A";
  return (
    <div className="version-display">
      <span>Current Version: v{packageJson.version}</span>
      {showRelease && <span>Released on: {formatBuildDate(buildDate)}</span>}
    </div>
  );
};

export default DisplayVersion;
